/*
 * Interface strings for the "play" area. Keys are the Russian source strings exactly as they
 * appear in the components; a missing key falls back to Russian, so a partial dictionary is safe.
 * Russian itself is never listed here — it is the key.
 */
const play = {
  english: {
    "📝 Базовая память": "📝 Basic memory",
    "📚 Расширенная память": "📚 Extended memory",
    "Цена ×1 · обычная память персонажей": "Price ×1 · standard character memory",
    "Цена ×2 · персонажи помнят больше": "Price ×2 · characters remember more",
    "🔄 Перезагрузить диалог": "🔄 Reload dialogue",
    "✅ Диалог перезагрузится со следующим сообщением": "✅ Dialogue will reload with the next message",
    "Используйте, когда в нескольких сообщениях подряд есть ошибки в тексте: сильные повторы, много иностранных слов или другие ошибки. ИИ частично забудет последние 20 сообщений. После перезагрузки кратко опишите в следующем сообщении, что сейчас происходит, чтобы персонажи вспомнили, что было.": "Use it when several messages in a row have broken text: heavy repetition, lots of foreign words or other bugs. The AI will partially forget the last 20 messages. After reloading, briefly describe what is happening right now in your next message so the characters remember what happened.",
    "Лор сохранён": "Lore saved",
    "📜 Свой лор": "📜 Own lore",
    "Дополнительные детали истории": "Additional story details",
    "Например: у героя есть старший брат, в городе действует тайный орден магов...": "For example: the hero has an older brother, a secret order of mages operates in the city...",
    "Сириус": "Sirius",
    "Аврора": "Aurora",
    "Вега": "Vega",
    "🎨 Стиль изображений": "🎨 Image style",
    "🤖 Модель генерации": "🤖 Generation model",
    'Спасибо, что прошли новеллу!': 'Thank you for playing!',
    "Произошла ошибка. Попробуйте снова или позже.": "Something went wrong. Please try again, or a bit later.",
    "Пожелания сохранены": "Preferences saved",
    "Вы": "You",
    "Дневной лимит взаимодействий для этой история исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "You've hit today's interaction limit for this story. Come back tomorrow!\n\nYou can return in {0} hours to continue this story.",
    "Дневной лимит взаимодействий для этой истории исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "You've hit today's interaction limit for this story. Come back tomorrow!\n\nYou can return in {0} hours to continue this story.",
    "Настройки изображений сохранены": "Image settings saved",
    "← Выйти": "← Exit",
    "Настройка вашего персонажа": "Set up your character",
    "Имя вашего персонажа": "Your character's name",
    "Ваш пол": "Your gender",
    "Мужской": "Male",
    "Женский": "Female",
    "Добавить вашу биографию": "Add your backstory",
    "Описание персонажа": "Character description",
    "Добавьте дополнительные детали персонажа (максимум 2500 символов)...": "Add more details about your character (2500 characters max)...",
    "Мне исполнилось 18 лет": "I am 18 or older",
    "Отправить": "Submit",
    "Что-то пошло не так...": "Something went wrong...",
    "Вернуться к поиску": "Back to search",
    "Загрузка...": "Loading...",
    'Играть — {0}': "Play — {0}",
    "Мир: персонажи и локации": "World: characters and locations",
    "Показать персонажей": "Show characters",
    "Скрыть персонажей": "Hide characters",
    "Выборы:": "Choices:",
    "Введите ваше сообщение...": "Type your message...",
    "Подсказка": "Suggest",
    "Варианты ответа": "Reply options",
    "Не удалось получить подсказки": "Could not get suggestions",
    "Продолжить ➤": "Continue ➤",
    "Нажмите на экран для продолжения": "Tap the screen to continue",
    "Меню": "Menu",
    "История": "History",
    "Мир": "World",
    "Скрыть": "Hide",
    "Спрайты": "Sprites",
    "Скажи что-нибудь первым!": "Say something first!",
    "Это сцена открытого мира! Вы управляете сюжетом.": "This is an open-world scene! You drive the story.",
    "Описывайте новых персонажей прямо в сообщении, например: «К нам подходит загадочная девушка в красном платье».": "Describe new characters right in your message, for example: “A mysterious girl in a red dress walks up to us.”",
    "Меняйте локацию: «Мы идём в заброшенный замок».": "Change location: “We head for the abandoned castle.”",
    "Каждая генерация изображения стоит {0} ⭐ (изображение генерируется только при создании нового персонажа или локации).": "Each generated image costs {0} ⭐ (an image is only generated when a new character or location appears).",
    "Если вы отключите генерацию изображений, рекомендуем использовать режим чата. Включите его в меню.": "If you turn image generation off, we recommend chat mode. You can enable it in the menu.",
    "Генерация изображений ({0} ⭐ за изображение)": "Image generation ({0} ⭐ per image)",
    "Аниме": "Anime",
    "Реалистичный": "Realistic",
    "Понятно": "Got it",
    "Спасибо, что прошли новеллу. Делитесь впечатлениями в нашем чате - нам очень важна обратная связь.": "Thanks for playing the novel through to the end. Share your impressions in our chat — your feedback means a lot to us.",
    "Поддержать проект можно через Telegram бота @ainovel_helper_bot.": "You can support the project through the Telegram bot @ainovel_helper_bot.",
    "Вернуться на главную": "Back to home",
    "Требуется подписка на Telegram": "Telegram subscription required",
    "Присоединитесь к нашей Telegram группе, затем перейдите к {0} и вставьте этот код верификации. Если вы уже в группе, просто вставьте код боту.": "Join our Telegram group, then open {0} and paste this verification code. If you're already in the group, just send the code to the bot.",
    "Обновите страницу после подтверждения подписки": "Refresh the page once your subscription is confirmed",
    "Присоединиться к группе": "Join the group",
    "Скопировано!": "Copied!",
    "Открыть Telegram бота": "Open Telegram bot",
    "Обновить": "Refresh",
    "Требуется оплата": "Payment required",
    "Требуется вход": "Sign-in required",
    "Цена: {0} Telegram Stars или {1} рублей через банк": "Price: {0} Telegram Stars or {1} roubles by bank transfer",
    "Перейдите в {0}, вставьте эту строку и оплатите с помощью Stars или через денежный перевод в банк. У бота есть все необходимые инструкции. Затем вернитесь и обновите страницу.": "Open {0}, paste this string and pay with Stars or by bank transfer. The bot has all the instructions you need. Then come back and refresh the page.",
    "Пожалуйста, войдите или зарегистрируйтесь для покупки этого контента.": "Please sign in or create an account to buy this content.",
    "Сообщение для вставки в бота:": "Message to paste into the bot:",
    "Скопировать": "Copy",
    "Войти": "Sign in",
    "⭐ Недостаточно звёзд": "⭐ Not enough stars",
    "Недостаточно звёзд для этого хода. Нужно больше ⭐ для взаимодействия с персонажами.": "Not enough stars for this turn. You need more ⭐ to interact with the characters.",
    " + {0} ⭐ за каждое сгенерированное изображение": " + {0} ⭐ for each generated image",
    "1 ход стоит минимум 10 ⭐": "One turn costs at least 10 ⭐",
    "Пополнить звёзды в Моём аккаунте": "Top up stars in My account",
    "📺 Или смотрите рекламу и получайте бесплатные звёзды": "📺 Or watch ads and earn free stars",
    "Отмена": "Cancel",
    "Доступ ограничен — CSAM": "Access restricted — CSAM",
    "Ваш запрос нарушил правила безопасности контента ({0}/5).": "Your request violated the content safety rules ({0}/5).",
    "Вы достигли максимального количества нарушений и не можете продолжать играть в новеллы.": "You have reached the maximum number of violations and can no longer play novels.",
    "При достижении 5 нарушений доступ к новеллам будет заблокирован.": "Once you reach 5 violations, access to the novels will be blocked.",
    "Если вы считаете, что это ошибка, напишите нам:": "If you believe this is a mistake, write to us:",
    "Вернуться к сообщению?": "Go back to this message?",
    "Прогресс после этого сообщения будет недоступен для продолжения, если вы не сделали сохранение. Вернуться к этому моменту?": "Progress made after this message can no longer be continued unless you saved it. Go back to this point?",
    "Вернуться": "Go back",
    "Сохранения": "Saves",
    "Загрузить": "Load",
    "Удалить": "Delete",
    "Сохранений не найдено": "No saves found",
    "Имя сохранения": "Save name",
    "Сохранить": "Save",
    "📜 История": "📜 History",
    "Нажмите, чтобы перейти к этому сообщению": "Tap to jump to this message",
    "Текущее": "Current",
    "История пуста": "History is empty",
    "🔇 Остановить музыку": "🔇 Stop music",
    "🎵 Включить музыку": "🎵 Play music",
    "💾 Сохранения": "💾 Saves",
    "🔍 Выйти из полноэкранного режима": "🔍 Exit fullscreen",
    "⛶ Полноэкранный режим": "⛶ Fullscreen",
    "👥 Кол-во показывающихся персонажей: {0}": "👥 Characters shown on screen: {0}",
    "🎭 Визуальный режим": "🎭 Visual mode",
    "💬 Режим чата": "💬 Chat mode",
    "✍️ Пожелания к ответам ИИ": "✍️ AI response preferences",
    "🔄 Новая игра / изменить биографию": "🔄 New game / edit backstory",
    "🚩 Сообщить об ошибке / задать вопрос": "🚩 Report a bug / ask a question",
    "🏠 Вернуться на главную": "🏠 Back to home",
    "Как ИИ должен писать ответы": "How the AI should write its replies",
    "Например: пиши длиннее и подробнее, больше описаний окружения, меньше вопросов в конце реплик...": "For example: write longer and more detailed replies, more description of the surroundings, fewer questions at the end...",
    "Сохранение...": "Saving...",
    "💾 Сохранить": "💾 Save",
    "🌍 Мир": "🌍 World",
    "Не удалось загрузить информацию.": "Couldn't load the information.",
    "📍 Вы здесь:": "📍 You are here:",
    "Неизвестно": "Unknown",
    "👤 В сцене:": "👤 In the scene:",
    "Никого": "No one",
    "🎨 Стиль изображений": "🎨 Image style",
    "💾 Сохранить настройки изображений": "💾 Save image settings",
    "👥 Персонажи": "👥 Characters",
    "Пока нет персонажей.": "No characters yet.",
    "Без имени": "Unnamed",
    "💀 Мёртв": "💀 Dead",
    "● В сцене": "● In the scene",
    "🗺️ Локации": "🗺️ Locations",
    "Пока нет локаций.": "No locations yet.",
    "📍 Здесь": "📍 Here",
    "🤖 Выбрать ИИ Модель": "🤖 Choose an AI model",
    " + {0} ⭐/изображение": " + {0} ⭐/image",
    "⚠️ Тестовая модель": "⚠️ Experimental model",
    "Эта модель тестовая и может ошибаться. Если что-то не понравится — вернитесь к 💍 Принцессе или 👑 Королеве, они самые надёжные.": "This model is experimental and can get things wrong. If you don't like the result, go back to 💍 Princess or 👑 Queen — they are the most reliable.",
    "Также лучше сменить локацию (сделать выбор), чтобы диалог стал пустым — новую модель лучше начинать с чистого листа.": "It's also better to change location (make a choice) so the dialogue starts empty — a new model does best from a clean slate.",
    "Понятно, выбрать": "Got it, select",
    "Ошибка загрузки игры": "Failed to load the game",
    "Ошибка взаимодействия с игрой": "Error while interacting with the game",
    "Загрузка игры...": "Loading the game...",
    "Повторить": "Retry",
    "Вернуться к новелле": "Back to the novel",
    "Конец": "The End",
    "Отправка...": "Sending...",
    "Продолжить": "Continue",
  },
  german: {
    "📝 Базовая память": "📝 Basis-Gedächtnis",
    "📚 Расширенная память": "📚 Erweitertes Gedächtnis",
    "Цена ×1 · обычная память персонажей": "Preis ×1 · normales Gedächtnis der Figuren",
    "Цена ×2 · персонажи помнят больше": "Preis ×2 · Figuren erinnern sich an mehr",
    "🔄 Перезагрузить диалог": "🔄 Dialog neu laden",
    "✅ Диалог перезагрузится со следующим сообщением": "✅ Der Dialog wird mit der nächsten Nachricht neu geladen",
    "Используйте, когда в нескольких сообщениях подряд есть ошибки в тексте: сильные повторы, много иностранных слов или другие ошибки. ИИ частично забудет последние 20 сообщений. После перезагрузки кратко опишите в следующем сообщении, что сейчас происходит, чтобы персонажи вспомнили, что было.": "Verwende es, wenn mehrere Nachrichten hintereinander fehlerhaften Text enthalten: starke Wiederholungen, viele fremdsprachige Wörter oder andere Fehler. Die KI vergisst die letzten 20 Nachrichten teilweise. Beschreibe nach dem Neuladen in deiner nächsten Nachricht kurz, was gerade passiert, damit sich die Figuren erinnern, was war.",
    "Лор сохранён": "Lore gespeichert",
    "📜 Свой лор": "📜 Eigene Lore",
    "Дополнительные детали истории": "Zusätzliche Details zur Geschichte",
    "Например: у героя есть старший брат, в городе действует тайный орден магов...": "Zum Beispiel: Der Held hat einen älteren Bruder, in der Stadt wirkt ein geheimer Magierorden...",
    "Сириус": "Sirius",
    "Аврора": "Aurora",
    "Вега": "Wega",
    "🎨 Стиль изображений": "🎨 Bildstil",
    "🤖 Модель генерации": "🤖 Generierungsmodell",
    'Спасибо, что прошли новеллу!': 'Danke, dass du die Novelle gespielt hast!',
    "Произошла ошибка. Попробуйте снова или позже.": "Etwas ist schiefgelaufen. Bitte versuche es noch einmal oder später.",
    "Пожелания сохранены": "Wünsche gespeichert",
    "Вы": "Du",
    "Дневной лимит взаимодействий для этой история исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "Das tägliche Interaktionslimit für diese Geschichte ist erreicht. Komm morgen wieder!\n\nIn {0} Stunden kannst du hier weitermachen.",
    "Дневной лимит взаимодействий для этой истории исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "Das tägliche Interaktionslimit für diese Geschichte ist erreicht. Komm morgen wieder!\n\nIn {0} Stunden kannst du hier weitermachen.",
    "Настройки изображений сохранены": "Bildeinstellungen gespeichert",
    "← Выйти": "← Verlassen",
    "Настройка вашего персонажа": "Deinen Charakter einrichten",
    "Имя вашего персонажа": "Name deines Charakters",
    "Ваш пол": "Dein Geschlecht",
    "Мужской": "Männlich",
    "Женский": "Weiblich",
    "Добавить вашу биографию": "Biografie hinzufügen",
    "Описание персонажа": "Charakterbeschreibung",
    "Добавьте дополнительные детали персонажа (максимум 2500 символов)...": "Weitere Details zu deinem Charakter (max. 2500 Zeichen)...",
    "Мне исполнилось 18 лет": "Ich bin 18 Jahre oder älter",
    "Отправить": "Absenden",
    "Что-то пошло не так...": "Etwas ist schiefgelaufen...",
    "Вернуться к поиску": "Zurück zur Suche",
    "Загрузка...": "Lädt...",
    'Играть — {0}': "Spielen — {0}",
    "Мир: персонажи и локации": "Welt: Charaktere und Orte",
    "Показать персонажей": "Charaktere anzeigen",
    "Скрыть персонажей": "Charaktere ausblenden",
    "Выборы:": "Optionen:",
    "Введите ваше сообщение...": "Nachricht eingeben...",
    "Подсказка": "Vorschlag",
    "Варианты ответа": "Antwortvorschläge",
    "Не удалось получить подсказки": "Vorschläge konnten nicht geladen werden",
    "Продолжить ➤": "Weiter ➤",
    "Нажмите на экран для продолжения": "Zum Fortfahren auf den Bildschirm tippen",
    "Меню": "Menü",
    "История": "Verlauf",
    "Мир": "Welt",
    "Скрыть": "Verbergen",
    "Спрайты": "Sprites",
    "Скажи что-нибудь первым!": "Sag zuerst etwas!",
    "Это сцена открытого мира! Вы управляете сюжетом.": "Das ist eine Open-World-Szene! Du bestimmst die Handlung.",
    "Описывайте новых персонажей прямо в сообщении, например: «К нам подходит загадочная девушка в красном платье».": "Beschreibe neue Charaktere direkt in deiner Nachricht, zum Beispiel: „Ein geheimnisvolles Mädchen in einem roten Kleid kommt auf uns zu.“",
    "Меняйте локацию: «Мы идём в заброшенный замок».": "Wechsle den Ort: „Wir gehen zur verlassenen Burg.“",
    "Каждая генерация изображения стоит {0} ⭐ (изображение генерируется только при создании нового персонажа или локации).": "Jede Bildgenerierung kostet {0} ⭐ (ein Bild entsteht nur, wenn ein neuer Charakter oder Ort auftaucht).",
    "Если вы отключите генерацию изображений, рекомендуем использовать режим чата. Включите его в меню.": "Wenn du die Bildgenerierung ausschaltest, empfehlen wir den Chat-Modus. Du kannst ihn im Menü aktivieren.",
    "Генерация изображений ({0} ⭐ за изображение)": "Bildgenerierung ({0} ⭐ pro Bild)",
    "Аниме": "Anime",
    "Реалистичный": "Realistisch",
    "Понятно": "Verstanden",
    "Спасибо, что прошли новеллу. Делитесь впечатлениями в нашем чате - нам очень важна обратная связь.": "Danke, dass du die Novel durchgespielt hast. Teile deine Eindrücke in unserem Chat — dein Feedback ist uns sehr wichtig.",
    "Поддержать проект можно через Telegram бота @ainovel_helper_bot.": "Du kannst das Projekt über den Telegram-Bot @ainovel_helper_bot unterstützen.",
    "Вернуться на главную": "Zurück zur Startseite",
    "Требуется подписка на Telegram": "Telegram-Abo erforderlich",
    "Присоединитесь к нашей Telegram группе, затем перейдите к {0} и вставьте этот код верификации. Если вы уже в группе, просто вставьте код боту.": "Tritt unserer Telegram-Gruppe bei, öffne dann {0} und füge diesen Bestätigungscode ein. Wenn du schon in der Gruppe bist, schick den Code einfach an den Bot.",
    "Обновите страницу после подтверждения подписки": "Lade die Seite neu, sobald dein Abo bestätigt ist",
    "Присоединиться к группе": "Gruppe beitreten",
    "Скопировано!": "Kopiert!",
    "Открыть Telegram бота": "Telegram-Bot öffnen",
    "Обновить": "Aktualisieren",
    "Требуется оплата": "Zahlung erforderlich",
    "Требуется вход": "Anmeldung erforderlich",
    "Цена: {0} Telegram Stars или {1} рублей через банк": "Preis: {0} Telegram Stars oder {1} Rubel per Banküberweisung",
    "Перейдите в {0}, вставьте эту строку и оплатите с помощью Stars или через денежный перевод в банк. У бота есть все необходимые инструкции. Затем вернитесь и обновите страницу.": "Öffne {0}, füge diese Zeichenfolge ein und bezahle mit Stars oder per Banküberweisung. Der Bot hat alle nötigen Anweisungen. Komm dann zurück und lade die Seite neu.",
    "Пожалуйста, войдите или зарегистрируйтесь для покупки этого контента.": "Bitte melde dich an oder registriere dich, um diesen Inhalt zu kaufen.",
    "Сообщение для вставки в бота:": "Nachricht zum Einfügen in den Bot:",
    "Скопировать": "Kopieren",
    "Войти": "Anmelden",
    "⭐ Недостаточно звёзд": "⭐ Nicht genug Sterne",
    "Недостаточно звёзд для этого хода. Нужно больше ⭐ для взаимодействия с персонажами.": "Nicht genug Sterne für diesen Zug. Du brauchst mehr ⭐, um mit den Charakteren zu interagieren.",
    " + {0} ⭐ за каждое сгенерированное изображение": " + {0} ⭐ für jedes generierte Bild",
    "1 ход стоит минимум 10 ⭐": "Ein Zug kostet mindestens 10 ⭐",
    "Пополнить звёзды в Моём аккаунте": "Sterne unter Mein Konto aufladen",
    "📺 Или смотрите рекламу и получайте бесплатные звёзды": "📺 Oder schau Werbung und erhalte kostenlose Sterne",
    "Отмена": "Abbrechen",
    "Доступ ограничен — CSAM": "Zugriff eingeschränkt — CSAM",
    "Ваш запрос нарушил правила безопасности контента ({0}/5).": "Deine Anfrage hat gegen die Inhaltssicherheitsregeln verstoßen ({0}/5).",
    "Вы достигли максимального количества нарушений и не можете продолжать играть в новеллы.": "Du hast die maximale Anzahl an Verstößen erreicht und kannst keine Novels mehr spielen.",
    "При достижении 5 нарушений доступ к новеллам будет заблокирован.": "Bei 5 Verstößen wird der Zugang zu den Novels gesperrt.",
    "Если вы считаете, что это ошибка, напишите нам:": "Wenn du glaubst, das ist ein Fehler, schreib uns:",
    "Вернуться к сообщению?": "Zu dieser Nachricht zurückkehren?",
    "Прогресс после этого сообщения будет недоступен для продолжения, если вы не сделали сохранение. Вернуться к этому моменту?": "Der Fortschritt nach dieser Nachricht lässt sich nicht mehr fortsetzen, wenn du nicht gespeichert hast. Zu diesem Punkt zurückkehren?",
    "Вернуться": "Zurückkehren",
    "Сохранения": "Spielstände",
    "Загрузить": "Laden",
    "Удалить": "Löschen",
    "Сохранений не найдено": "Keine Spielstände gefunden",
    "Имя сохранения": "Name des Spielstands",
    "Сохранить": "Speichern",
    "📜 История": "📜 Verlauf",
    "Нажмите, чтобы перейти к этому сообщению": "Tippen, um zu dieser Nachricht zu springen",
    "Текущее": "Aktuell",
    "История пуста": "Verlauf ist leer",
    "🔇 Остановить музыку": "🔇 Musik stoppen",
    "🎵 Включить музыку": "🎵 Musik einschalten",
    "💾 Сохранения": "💾 Spielstände",
    "🔍 Выйти из полноэкранного режима": "🔍 Vollbild verlassen",
    "⛶ Полноэкранный режим": "⛶ Vollbild",
    "👥 Кол-во показывающихся персонажей: {0}": "👥 Angezeigte Charaktere: {0}",
    "🎭 Визуальный режим": "🎭 Visueller Modus",
    "💬 Режим чата": "💬 Chat-Modus",
    "✍️ Пожелания к ответам ИИ": "✍️ Wünsche für KI-Antworten",
    "🔄 Новая игра / изменить биографию": "🔄 Neues Spiel / Biografie ändern",
    "🚩 Сообщить об ошибке / задать вопрос": "🚩 Fehler melden / Frage stellen",
    "🏠 Вернуться на главную": "🏠 Zurück zur Startseite",
    "Как ИИ должен писать ответы": "Wie die KI ihre Antworten schreiben soll",
    "Например: пиши длиннее и подробнее, больше описаний окружения, меньше вопросов в конце реплик...": "Zum Beispiel: schreibe länger und ausführlicher, mehr Beschreibungen der Umgebung, weniger Fragen am Ende...",
    "Сохранение...": "Wird gespeichert...",
    "💾 Сохранить": "💾 Speichern",
    "🌍 Мир": "🌍 Welt",
    "Не удалось загрузить информацию.": "Informationen konnten nicht geladen werden.",
    "📍 Вы здесь:": "📍 Du bist hier:",
    "Неизвестно": "Unbekannt",
    "👤 В сцене:": "👤 In der Szene:",
    "Никого": "Niemand",
    "🎨 Стиль изображений": "🎨 Bildstil",
    "💾 Сохранить настройки изображений": "💾 Bildeinstellungen speichern",
    "👥 Персонажи": "👥 Charaktere",
    "Пока нет персонажей.": "Noch keine Charaktere.",
    "Без имени": "Ohne Namen",
    "💀 Мёртв": "💀 Tot",
    "● В сцене": "● In der Szene",
    "🗺️ Локации": "🗺️ Orte",
    "Пока нет локаций.": "Noch keine Orte.",
    "📍 Здесь": "📍 Hier",
    "🤖 Выбрать ИИ Модель": "🤖 KI-Modell wählen",
    " + {0} ⭐/изображение": " + {0} ⭐/Bild",
    "⚠️ Тестовая модель": "⚠️ Testmodell",
    "Эта модель тестовая и может ошибаться. Если что-то не понравится — вернитесь к 💍 Принцессе или 👑 Королеве, они самые надёжные.": "Dieses Modell ist ein Testmodell und kann Fehler machen. Wenn dir etwas nicht gefällt, wechsle zurück zu 💍 Prinzessin oder 👑 Königin — sie sind am zuverlässigsten.",
    "Также лучше сменить локацию (сделать выбор), чтобы диалог стал пустым — новую модель лучше начинать с чистого листа.": "Am besten wechselst du auch den Ort (triff eine Auswahl), damit der Dialog leer ist — ein neues Modell startet besser mit einem sauberen Blatt.",
    "Понятно, выбрать": "Verstanden, auswählen",
    "Ошибка загрузки игры": "Fehler beim Laden des Spiels",
    "Ошибка взаимодействия с игрой": "Fehler bei der Interaktion mit dem Spiel",
    "Загрузка игры...": "Spiel wird geladen...",
    "Повторить": "Erneut versuchen",
    "Вернуться к новелле": "Zurück zur Novel",
    "Конец": "Ende",
    "Отправка...": "Wird gesendet...",
    "Продолжить": "Weiter",
  },
  french: {
    "📝 Базовая память": "📝 Mémoire de base",
    "📚 Расширенная память": "📚 Mémoire étendue",
    "Цена ×1 · обычная память персонажей": "Prix ×1 · mémoire standard des personnages",
    "Цена ×2 · персонажи помнят больше": "Prix ×2 · les personnages se souviennent de plus",
    "🔄 Перезагрузить диалог": "🔄 Recharger le dialogue",
    "✅ Диалог перезагрузится со следующим сообщением": "✅ Le dialogue sera rechargé au prochain message",
    "Используйте, когда в нескольких сообщениях подряд есть ошибки в тексте: сильные повторы, много иностранных слов или другие ошибки. ИИ частично забудет последние 20 сообщений. После перезагрузки кратко опишите в следующем сообщении, что сейчас происходит, чтобы персонажи вспомнили, что было.": "À utiliser quand plusieurs messages d'affilée contiennent un texte défectueux : répétitions excessives, beaucoup de mots étrangers ou d'autres bugs. L'IA oubliera en partie les 20 derniers messages. Après le rechargement, décris brièvement dans ton prochain message ce qui se passe en ce moment, pour que les personnages se souviennent de ce qui s'est passé.",
    "Лор сохранён": "Lore enregistré",
    "📜 Свой лор": "📜 Mon lore",
    "Дополнительные детали истории": "Détails supplémentaires de l'histoire",
    "Например: у героя есть старший брат, в городе действует тайный орден магов...": "Par exemple : le héros a un frère aîné, un ordre secret de mages agit dans la ville...",
    "Сириус": "Sirius",
    "Аврора": "Aurore",
    "Вега": "Véga",
    "🎨 Стиль изображений": "🎨 Style d'image",
    "🤖 Модель генерации": "🤖 Modèle de génération",
    'Спасибо, что прошли новеллу!': 'Merci d\'avoir joué à ce roman !',
    "Произошла ошибка. Попробуйте снова или позже.": "Une erreur s'est produite. Réessaie maintenant ou plus tard.",
    "Пожелания сохранены": "Préférences enregistrées",
    "Вы": "Vous",
    "Дневной лимит взаимодействий для этой история исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "Tu as atteint la limite d'interactions du jour pour cette histoire. Reviens demain !\n\nTu pourras reprendre cette histoire dans {0} heures.",
    "Дневной лимит взаимодействий для этой истории исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "Tu as atteint la limite d'interactions du jour pour cette histoire. Reviens demain !\n\nTu pourras reprendre cette histoire dans {0} heures.",
    "Настройки изображений сохранены": "Paramètres d'images enregistrés",
    "← Выйти": "← Quitter",
    "Настройка вашего персонажа": "Configure ton personnage",
    "Имя вашего персонажа": "Nom de ton personnage",
    "Ваш пол": "Ton genre",
    "Мужской": "Homme",
    "Женский": "Femme",
    "Добавить вашу биографию": "Ajouter ta biographie",
    "Описание персонажа": "Description du personnage",
    "Добавьте дополнительные детали персонажа (максимум 2500 символов)...": "Ajoute des détails sur ton personnage (2500 caractères max)...",
    "Мне исполнилось 18 лет": "J'ai 18 ans ou plus",
    "Отправить": "Envoyer",
    "Что-то пошло не так...": "Quelque chose s'est mal passé...",
    "Вернуться к поиску": "Retour à la recherche",
    "Загрузка...": "Chargement...",
    'Играть — {0}': "Jouer — {0}",
    "Мир: персонажи и локации": "Monde : personnages et lieux",
    "Показать персонажей": "Afficher les personnages",
    "Скрыть персонажей": "Masquer les personnages",
    "Выборы:": "Choix :",
    "Введите ваше сообщение...": "Écris ton message...",
    "Подсказка": "Suggestion",
    "Варианты ответа": "Idées de réponse",
    "Не удалось получить подсказки": "Impossible d'obtenir des suggestions",
    "Продолжить ➤": "Continuer ➤",
    "Нажмите на экран для продолжения": "Touche l'écran pour continuer",
    "Меню": "Menu",
    "История": "Historique",
    "Мир": "Monde",
    "Скрыть": "Masquer",
    "Спрайты": "Sprites",
    "Скажи что-нибудь первым!": "Dis quelque chose en premier !",
    "Это сцена открытого мира! Вы управляете сюжетом.": "C'est une scène en monde ouvert ! C'est toi qui mènes l'histoire.",
    "Описывайте новых персонажей прямо в сообщении, например: «К нам подходит загадочная девушка в красном платье».": "Décris les nouveaux personnages directement dans ton message, par exemple : « Une mystérieuse jeune femme en robe rouge s'approche de nous. »",
    "Меняйте локацию: «Мы идём в заброшенный замок».": "Change de lieu : « Nous allons au château abandonné. »",
    "Каждая генерация изображения стоит {0} ⭐ (изображение генерируется только при создании нового персонажа или локации).": "Chaque génération d'image coûte {0} ⭐ (une image n'est générée que lors de l'apparition d'un nouveau personnage ou lieu).",
    "Если вы отключите генерацию изображений, рекомендуем использовать режим чата. Включите его в меню.": "Si tu désactives la génération d'images, nous te conseillons le mode chat. Active-le dans le menu.",
    "Генерация изображений ({0} ⭐ за изображение)": "Génération d'images ({0} ⭐ par image)",
    "Аниме": "Anime",
    "Реалистичный": "Réaliste",
    "Понятно": "Compris",
    "Спасибо, что прошли новеллу. Делитесь впечатлениями в нашем чате - нам очень важна обратная связь.": "Merci d'avoir terminé le roman. Partage tes impressions dans notre chat — ton avis compte beaucoup pour nous.",
    "Поддержать проект можно через Telegram бота @ainovel_helper_bot.": "Tu peux soutenir le projet via le bot Telegram @ainovel_helper_bot.",
    "Вернуться на главную": "Retour à l'accueil",
    "Требуется подписка на Telegram": "Abonnement Telegram requis",
    "Присоединитесь к нашей Telegram группе, затем перейдите к {0} и вставьте этот код верификации. Если вы уже в группе, просто вставьте код боту.": "Rejoins notre groupe Telegram, puis ouvre {0} et colle ce code de vérification. Si tu es déjà dans le groupe, envoie simplement le code au bot.",
    "Обновите страницу после подтверждения подписки": "Actualise la page une fois l'abonnement confirmé",
    "Присоединиться к группе": "Rejoindre le groupe",
    "Скопировано!": "Copié !",
    "Открыть Telegram бота": "Ouvrir le bot Telegram",
    "Обновить": "Actualiser",
    "Требуется оплата": "Paiement requis",
    "Требуется вход": "Connexion requise",
    "Цена: {0} Telegram Stars или {1} рублей через банк": "Prix : {0} Telegram Stars ou {1} roubles par virement bancaire",
    "Перейдите в {0}, вставьте эту строку и оплатите с помощью Stars или через денежный перевод в банк. У бота есть все необходимые инструкции. Затем вернитесь и обновите страницу.": "Ouvre {0}, colle cette ligne et paie avec des Stars ou par virement bancaire. Le bot te donne toutes les instructions nécessaires. Reviens ensuite et actualise la page.",
    "Пожалуйста, войдите или зарегистрируйтесь для покупки этого контента.": "Connecte-toi ou crée un compte pour acheter ce contenu.",
    "Сообщение для вставки в бота:": "Message à coller dans le bot :",
    "Скопировать": "Copier",
    "Войти": "Se connecter",
    "⭐ Недостаточно звёзд": "⭐ Pas assez d'étoiles",
    "Недостаточно звёзд для этого хода. Нужно больше ⭐ для взаимодействия с персонажами.": "Pas assez d'étoiles pour ce tour. Il te faut plus de ⭐ pour interagir avec les personnages.",
    " + {0} ⭐ за каждое сгенерированное изображение": " + {0} ⭐ par image générée",
    "1 ход стоит минимум 10 ⭐": "Un tour coûte au minimum 10 ⭐",
    "Пополнить звёзды в Моём аккаунте": "Recharger des étoiles dans Mon compte",
    "📺 Или смотрите рекламу и получайте бесплатные звёзды": "📺 Ou regarde des pubs et gagne des étoiles gratuites",
    "Отмена": "Annuler",
    "Доступ ограничен — CSAM": "Accès restreint — CSAM",
    "Ваш запрос нарушил правила безопасности контента ({0}/5).": "Ta demande a enfreint les règles de sécurité du contenu ({0}/5).",
    "Вы достигли максимального количества нарушений и не можете продолжать играть в новеллы.": "Tu as atteint le nombre maximal d'infractions et ne peux plus jouer aux romans.",
    "При достижении 5 нарушений доступ к новеллам будет заблокирован.": "À 5 infractions, l'accès aux romans sera bloqué.",
    "Если вы считаете, что это ошибка, напишите нам:": "Si tu penses qu'il s'agit d'une erreur, écris-nous :",
    "Вернуться к сообщению?": "Revenir à ce message ?",
    "Прогресс после этого сообщения будет недоступен для продолжения, если вы не сделали сохранение. Вернуться к этому моменту?": "La progression après ce message ne pourra plus être reprise si tu n'as pas sauvegardé. Revenir à ce moment ?",
    "Вернуться": "Revenir",
    "Сохранения": "Sauvegardes",
    "Загрузить": "Charger",
    "Удалить": "Supprimer",
    "Сохранений не найдено": "Aucune sauvegarde",
    "Имя сохранения": "Nom de la sauvegarde",
    "Сохранить": "Enregistrer",
    "📜 История": "📜 Historique",
    "Нажмите, чтобы перейти к этому сообщению": "Touche pour revenir à ce message",
    "Текущее": "Actuel",
    "История пуста": "Historique vide",
    "🔇 Остановить музыку": "🔇 Couper la musique",
    "🎵 Включить музыку": "🎵 Activer la musique",
    "💾 Сохранения": "💾 Sauvegardes",
    "🔍 Выйти из полноэкранного режима": "🔍 Quitter le plein écran",
    "⛶ Полноэкранный режим": "⛶ Plein écran",
    "👥 Кол-во показывающихся персонажей: {0}": "👥 Personnages affichés : {0}",
    "🎭 Визуальный режим": "🎭 Mode visuel",
    "💬 Режим чата": "💬 Mode chat",
    "✍️ Пожелания к ответам ИИ": "✍️ Préférences pour les réponses de l'IA",
    "🔄 Новая игра / изменить биографию": "🔄 Nouvelle partie / modifier la biographie",
    "🚩 Сообщить об ошибке / задать вопрос": "🚩 Signaler un bug / poser une question",
    "🏠 Вернуться на главную": "🏠 Retour à l'accueil",
    "Как ИИ должен писать ответы": "Comment l'IA doit rédiger ses réponses",
    "Например: пиши длиннее и подробнее, больше описаний окружения, меньше вопросов в конце реплик...": "Par exemple : écris des réponses plus longues et détaillées, décris davantage les décors, moins de questions à la fin...",
    "Сохранение...": "Enregistrement...",
    "💾 Сохранить": "💾 Enregistrer",
    "🌍 Мир": "🌍 Monde",
    "Не удалось загрузить информацию.": "Impossible de charger les informations.",
    "📍 Вы здесь:": "📍 Tu es ici :",
    "Неизвестно": "Inconnu",
    "👤 В сцене:": "👤 Dans la scène :",
    "Никого": "Personne",
    "🎨 Стиль изображений": "🎨 Style des images",
    "💾 Сохранить настройки изображений": "💾 Enregistrer les réglages d'images",
    "👥 Персонажи": "👥 Personnages",
    "Пока нет персонажей.": "Pas encore de personnages.",
    "Без имени": "Sans nom",
    "💀 Мёртв": "💀 Mort",
    "● В сцене": "● Dans la scène",
    "🗺️ Локации": "🗺️ Lieux",
    "Пока нет локаций.": "Pas encore de lieux.",
    "📍 Здесь": "📍 Ici",
    "🤖 Выбрать ИИ Модель": "🤖 Choisir un modèle d'IA",
    " + {0} ⭐/изображение": " + {0} ⭐/image",
    "⚠️ Тестовая модель": "⚠️ Modèle en test",
    "Эта модель тестовая и может ошибаться. Если что-то не понравится — вернитесь к 💍 Принцессе или 👑 Королеве, они самые надёжные.": "Ce modèle est en test et peut se tromper. Si le résultat ne te plaît pas, reviens à 💍 Princesse ou 👑 Reine : ce sont les plus fiables.",
    "Также лучше сменить локацию (сделать выбор), чтобы диалог стал пустым — новую модель лучше начинать с чистого листа.": "Mieux vaut aussi changer de lieu (fais un choix) pour repartir sur un dialogue vide : un nouveau modèle démarre mieux de zéro.",
    "Понятно, выбрать": "Compris, choisir",
    "Ошибка загрузки игры": "Échec du chargement de la partie",
    "Ошибка взаимодействия с игрой": "Erreur lors de l'interaction avec la partie",
    "Загрузка игры...": "Chargement de la partie...",
    "Повторить": "Réessayer",
    "Вернуться к новелле": "Retour au roman",
    "Конец": "Fin",
    "Отправка...": "Envoi...",
    "Продолжить": "Continuer",
  },
  spanish: {
    "📝 Базовая память": "📝 Memoria básica",
    "📚 Расширенная память": "📚 Memoria ampliada",
    "Цена ×1 · обычная память персонажей": "Precio ×1 · memoria estándar de los personajes",
    "Цена ×2 · персонажи помнят больше": "Precio ×2 · los personajes recuerdan más",
    "🔄 Перезагрузить диалог": "🔄 Recargar diálogo",
    "✅ Диалог перезагрузится со следующим сообщением": "✅ El diálogo se recargará con el próximo mensaje",
    "Используйте, когда в нескольких сообщениях подряд есть ошибки в тексте: сильные повторы, много иностранных слов или другие ошибки. ИИ частично забудет последние 20 сообщений. После перезагрузки кратко опишите в следующем сообщении, что сейчас происходит, чтобы персонажи вспомнили, что было.": "Úsalo cuando varios mensajes seguidos tengan texto defectuoso: muchas repeticiones, muchas palabras extranjeras u otros errores. La IA olvidará en parte los últimos 20 mensajes. Después de recargar, describe brevemente en tu próximo mensaje lo que está pasando ahora, para que los personajes recuerden lo que ocurrió.",
    "Лор сохранён": "Lore guardado",
    "📜 Свой лор": "📜 Lore propio",
    "Дополнительные детали истории": "Detalles adicionales de la historia",
    "Например: у героя есть старший брат, в городе действует тайный орден магов...": "Por ejemplo: el héroe tiene un hermano mayor, en la ciudad actúa una orden secreta de magos...",
    "Сириус": "Sirio",
    "Аврора": "Aurora",
    "Вега": "Vega",
    "🎨 Стиль изображений": "🎨 Estilo de imagen",
    "🤖 Модель генерации": "🤖 Modelo de generación",
    'Спасибо, что прошли новеллу!': '¡Gracias por jugar a esta novela!',
    "Произошла ошибка. Попробуйте снова или позже.": "Se ha producido un error. Inténtalo de nuevo o más tarde.",
    "Пожелания сохранены": "Preferencias guardadas",
    "Вы": "Tú",
    "Дневной лимит взаимодействий для этой история исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "Has alcanzado el límite diario de interacciones de esta historia. ¡Vuelve mañana!\n\nPodrás continuar esta historia en {0} horas.",
    "Дневной лимит взаимодействий для этой истории исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "Has alcanzado el límite diario de interacciones de esta historia. ¡Vuelve mañana!\n\nPodrás continuar esta historia en {0} horas.",
    "Настройки изображений сохранены": "Ajustes de imagen guardados",
    "← Выйти": "← Salir",
    "Настройка вашего персонажа": "Configura tu personaje",
    "Имя вашего персонажа": "Nombre de tu personaje",
    "Ваш пол": "Tu género",
    "Мужской": "Hombre",
    "Женский": "Mujer",
    "Добавить вашу биографию": "Añadir tu biografía",
    "Описание персонажа": "Descripción del personaje",
    "Добавьте дополнительные детали персонажа (максимум 2500 символов)...": "Añade más detalles sobre tu personaje (máximo 2500 caracteres)...",
    "Мне исполнилось 18 лет": "Tengo 18 años o más",
    "Отправить": "Enviar",
    "Что-то пошло не так...": "Algo ha salido mal...",
    "Вернуться к поиску": "Volver a la búsqueda",
    "Загрузка...": "Cargando...",
    'Играть — {0}': "Jugar — {0}",
    "Мир: персонажи и локации": "Mundo: personajes y lugares",
    "Показать персонажей": "Mostrar personajes",
    "Скрыть персонажей": "Ocultar personajes",
    "Выборы:": "Opciones:",
    "Введите ваше сообщение...": "Escribe tu mensaje...",
    "Подсказка": "Sugerencia",
    "Варианты ответа": "Opciones de respuesta",
    "Не удалось получить подсказки": "No se pudieron obtener sugerencias",
    "Продолжить ➤": "Continuar ➤",
    "Нажмите на экран для продолжения": "Toca la pantalla para continuar",
    "Меню": "Menú",
    "История": "Historial",
    "Мир": "Mundo",
    "Скрыть": "Ocultar",
    "Спрайты": "Sprites",
    "Скажи что-нибудь первым!": "¡Di algo primero!",
    "Это сцена открытого мира! Вы управляете сюжетом.": "¡Esta es una escena de mundo abierto! Tú diriges la historia.",
    "Описывайте новых персонажей прямо в сообщении, например: «К нам подходит загадочная девушка в красном платье».": "Describe a los personajes nuevos en tu propio mensaje, por ejemplo: «Se nos acerca una chica misteriosa con un vestido rojo».",
    "Меняйте локацию: «Мы идём в заброшенный замок».": "Cambia de lugar: «Vamos al castillo abandonado».",
    "Каждая генерация изображения стоит {0} ⭐ (изображение генерируется только при создании нового персонажа или локации).": "Cada imagen generada cuesta {0} ⭐ (solo se genera una imagen al crear un personaje o un lugar nuevo).",
    "Если вы отключите генерацию изображений, рекомендуем использовать режим чата. Включите его в меню.": "Si desactivas la generación de imágenes, te recomendamos el modo chat. Puedes activarlo en el menú.",
    "Генерация изображений ({0} ⭐ за изображение)": "Generación de imágenes ({0} ⭐ por imagen)",
    "Аниме": "Anime",
    "Реалистичный": "Realista",
    "Понятно": "Entendido",
    "Спасибо, что прошли новеллу. Делитесь впечатлениями в нашем чате - нам очень важна обратная связь.": "Gracias por completar la novela. Comparte tus impresiones en nuestro chat: tu opinión es muy importante para nosotros.",
    "Поддержать проект можно через Telegram бота @ainovel_helper_bot.": "Puedes apoyar el proyecto a través del bot de Telegram @ainovel_helper_bot.",
    "Вернуться на главную": "Volver al inicio",
    "Требуется подписка на Telegram": "Se requiere suscripción en Telegram",
    "Присоединитесь к нашей Telegram группе, затем перейдите к {0} и вставьте этот код верификации. Если вы уже в группе, просто вставьте код боту.": "Únete a nuestro grupo de Telegram, luego abre {0} y pega este código de verificación. Si ya estás en el grupo, solo envía el código al bot.",
    "Обновите страницу после подтверждения подписки": "Actualiza la página cuando se confirme la suscripción",
    "Присоединиться к группе": "Unirse al grupo",
    "Скопировано!": "¡Copiado!",
    "Открыть Telegram бота": "Abrir el bot de Telegram",
    "Обновить": "Actualizar",
    "Требуется оплата": "Pago requerido",
    "Требуется вход": "Inicio de sesión requerido",
    "Цена: {0} Telegram Stars или {1} рублей через банк": "Precio: {0} Telegram Stars o {1} rublos por transferencia bancaria",
    "Перейдите в {0}, вставьте эту строку и оплатите с помощью Stars или через денежный перевод в банк. У бота есть все необходимые инструкции. Затем вернитесь и обновите страницу.": "Abre {0}, pega esta cadena y paga con Stars o por transferencia bancaria. El bot tiene todas las instrucciones necesarias. Luego vuelve y actualiza la página.",
    "Пожалуйста, войдите или зарегистрируйтесь для покупки этого контента.": "Inicia sesión o regístrate para comprar este contenido.",
    "Сообщение для вставки в бота:": "Mensaje para pegar en el bot:",
    "Скопировать": "Copiar",
    "Войти": "Iniciar sesión",
    "⭐ Недостаточно звёзд": "⭐ No tienes suficientes estrellas",
    "Недостаточно звёзд для этого хода. Нужно больше ⭐ для взаимодействия с персонажами.": "No tienes suficientes estrellas para este turno. Necesitas más ⭐ para interactuar con los personajes.",
    " + {0} ⭐ за каждое сгенерированное изображение": " + {0} ⭐ por cada imagen generada",
    "1 ход стоит минимум 10 ⭐": "Un turno cuesta como mínimo 10 ⭐",
    "Пополнить звёзды в Моём аккаунте": "Recargar estrellas en Mi cuenta",
    "📺 Или смотрите рекламу и получайте бесплатные звёзды": "📺 O mira anuncios y consigue estrellas gratis",
    "Отмена": "Cancelar",
    "Доступ ограничен — CSAM": "Acceso restringido — CSAM",
    "Ваш запрос нарушил правила безопасности контента ({0}/5).": "Tu solicitud ha infringido las normas de seguridad de contenido ({0}/5).",
    "Вы достигли максимального количества нарушений и не можете продолжать играть в новеллы.": "Has alcanzado el número máximo de infracciones y ya no puedes jugar a las novelas.",
    "При достижении 5 нарушений доступ к новеллам будет заблокирован.": "Al llegar a 5 infracciones se bloqueará el acceso a las novelas.",
    "Если вы считаете, что это ошибка, напишите нам:": "Si crees que se trata de un error, escríbenos:",
    "Вернуться к сообщению?": "¿Volver a este mensaje?",
    "Прогресс после этого сообщения будет недоступен для продолжения, если вы не сделали сохранение. Вернуться к этому моменту?": "El progreso posterior a este mensaje no se podrá continuar si no has guardado. ¿Volver a este momento?",
    "Вернуться": "Volver",
    "Сохранения": "Partidas guardadas",
    "Загрузить": "Cargar",
    "Удалить": "Eliminar",
    "Сохранений не найдено": "No se han encontrado partidas",
    "Имя сохранения": "Nombre de la partida",
    "Сохранить": "Guardar",
    "📜 История": "📜 Historial",
    "Нажмите, чтобы перейти к этому сообщению": "Toca para ir a este mensaje",
    "Текущее": "Actual",
    "История пуста": "El historial está vacío",
    "🔇 Остановить музыку": "🔇 Detener la música",
    "🎵 Включить музыку": "🎵 Activar la música",
    "💾 Сохранения": "💾 Partidas guardadas",
    "🔍 Выйти из полноэкранного режима": "🔍 Salir de pantalla completa",
    "⛶ Полноэкранный режим": "⛶ Pantalla completa",
    "👥 Кол-во показывающихся персонажей: {0}": "👥 Personajes mostrados: {0}",
    "🎭 Визуальный режим": "🎭 Modo visual",
    "💬 Режим чата": "💬 Modo chat",
    "✍️ Пожелания к ответам ИИ": "✍️ Preferencias para las respuestas de la IA",
    "🔄 Новая игра / изменить биографию": "🔄 Nueva partida / cambiar biografía",
    "🚩 Сообщить об ошибке / задать вопрос": "🚩 Informar de un error / hacer una pregunta",
    "🏠 Вернуться на главную": "🏠 Volver al inicio",
    "Как ИИ должен писать ответы": "Cómo debe escribir la IA sus respuestas",
    "Например: пиши длиннее и подробнее, больше описаний окружения, меньше вопросов в конце реплик...": "Por ejemplo: escribe respuestas más largas y detalladas, describe más el entorno, menos preguntas al final...",
    "Сохранение...": "Guardando...",
    "💾 Сохранить": "💾 Guardar",
    "🌍 Мир": "🌍 Mundo",
    "Не удалось загрузить информацию.": "No se ha podido cargar la información.",
    "📍 Вы здесь:": "📍 Estás aquí:",
    "Неизвестно": "Desconocido",
    "👤 В сцене:": "👤 En la escena:",
    "Никого": "Nadie",
    "🎨 Стиль изображений": "🎨 Estilo de imagen",
    "💾 Сохранить настройки изображений": "💾 Guardar ajustes de imagen",
    "👥 Персонажи": "👥 Personajes",
    "Пока нет персонажей.": "Todavía no hay personajes.",
    "Без имени": "Sin nombre",
    "💀 Мёртв": "💀 Muerto",
    "● В сцене": "● En la escena",
    "🗺️ Локации": "🗺️ Lugares",
    "Пока нет локаций.": "Todavía no hay lugares.",
    "📍 Здесь": "📍 Aquí",
    "🤖 Выбрать ИИ Модель": "🤖 Elegir modelo de IA",
    " + {0} ⭐/изображение": " + {0} ⭐/imagen",
    "⚠️ Тестовая модель": "⚠️ Modelo de prueba",
    "Эта модель тестовая и может ошибаться. Если что-то не понравится — вернитесь к 💍 Принцессе или 👑 Королеве, они самые надёжные.": "Este modelo es de prueba y puede equivocarse. Si algo no te convence, vuelve a 💍 Princesa o 👑 Reina: son las más fiables.",
    "Также лучше сменить локацию (сделать выбор), чтобы диалог стал пустым — новую модель лучше начинать с чистого листа.": "También conviene cambiar de lugar (elige una opción) para que el diálogo quede vacío: un modelo nuevo funciona mejor desde cero.",
    "Понятно, выбрать": "Entendido, elegir",
    "Ошибка загрузки игры": "Error al cargar la partida",
    "Ошибка взаимодействия с игрой": "Error al interactuar con la partida",
    "Загрузка игры...": "Cargando la partida...",
    "Повторить": "Reintentar",
    "Вернуться к новелле": "Volver a la novela",
    "Конец": "Fin",
    "Отправка...": "Enviando...",
    "Продолжить": "Continuar",
  },
  italian: {
    "📝 Базовая память": "📝 Memoria base",
    "📚 Расширенная память": "📚 Memoria estesa",
    "Цена ×1 · обычная память персонажей": "Prezzo ×1 · memoria standard dei personaggi",
    "Цена ×2 · персонажи помнят больше": "Prezzo ×2 · i personaggi ricordano di più",
    "🔄 Перезагрузить диалог": "🔄 Ricarica il dialogo",
    "✅ Диалог перезагрузится со следующим сообщением": "✅ Il dialogo verrà ricaricato con il prossimo messaggio",
    "Используйте, когда в нескольких сообщениях подряд есть ошибки в тексте: сильные повторы, много иностранных слов или другие ошибки. ИИ частично забудет последние 20 сообщений. После перезагрузки кратко опишите в следующем сообщении, что сейчас происходит, чтобы персонажи вспомнили, что было.": "Usalo quando più messaggi di fila contengono testo difettoso: troppe ripetizioni, molte parole straniere o altri errori. L'IA dimenticherà in parte gli ultimi 20 messaggi. Dopo il ricaricamento, descrivi brevemente nel prossimo messaggio cosa sta succedendo ora, così i personaggi ricordano cosa è successo.",
    "Лор сохранён": "Lore salvato",
    "📜 Свой лор": "📜 Lore personale",
    "Дополнительные детали истории": "Dettagli aggiuntivi della storia",
    "Например: у героя есть старший брат, в городе действует тайный орден магов...": "Per esempio: l'eroe ha un fratello maggiore, in città opera un ordine segreto di maghi...",
    "Сириус": "Sirio",
    "Аврора": "Aurora",
    "Вега": "Vega",
    "🎨 Стиль изображений": "🎨 Stile immagine",
    "🤖 Модель генерации": "🤖 Modello di generazione",
    'Спасибо, что прошли новеллу!': 'Grazie per aver giocato a questo romanzo!',
    "Произошла ошибка. Попробуйте снова или позже.": "Si è verificato un errore. Riprova ora o più tardi.",
    "Пожелания сохранены": "Preferenze salvate",
    "Вы": "Tu",
    "Дневной лимит взаимодействий для этой история исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "Hai raggiunto il limite giornaliero di interazioni per questa storia. Torna domani!\n\nPotrai riprendere questa storia tra {0} ore.",
    "Дневной лимит взаимодействий для этой истории исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "Hai raggiunto il limite giornaliero di interazioni per questa storia. Torna domani!\n\nPotrai riprendere questa storia tra {0} ore.",
    "Настройки изображений сохранены": "Impostazioni immagini salvate",
    "← Выйти": "← Esci",
    "Настройка вашего персонажа": "Configura il tuo personaggio",
    "Имя вашего персонажа": "Nome del tuo personaggio",
    "Ваш пол": "Il tuo genere",
    "Мужской": "Uomo",
    "Женский": "Donna",
    "Добавить вашу биографию": "Aggiungi la tua biografia",
    "Описание персонажа": "Descrizione del personaggio",
    "Добавьте дополнительные детали персонажа (максимум 2500 символов)...": "Aggiungi altri dettagli sul personaggio (massimo 2500 caratteri)...",
    "Мне исполнилось 18 лет": "Ho 18 anni o più",
    "Отправить": "Invia",
    "Что-то пошло не так...": "Qualcosa è andato storto...",
    "Вернуться к поиску": "Torna alla ricerca",
    "Загрузка...": "Caricamento...",
    'Играть — {0}': "Gioca — {0}",
    "Мир: персонажи и локации": "Mondo: personaggi e luoghi",
    "Показать персонажей": "Mostra personaggi",
    "Скрыть персонажей": "Nascondi personaggi",
    "Выборы:": "Scelte:",
    "Введите ваше сообщение...": "Scrivi il tuo messaggio...",
    "Подсказка": "Suggerimento",
    "Варианты ответа": "Opzioni di risposta",
    "Не удалось получить подсказки": "Impossibile ottenere suggerimenti",
    "Продолжить ➤": "Continua ➤",
    "Нажмите на экран для продолжения": "Tocca lo schermo per continuare",
    "Меню": "Menu",
    "История": "Cronologia",
    "Мир": "Mondo",
    "Скрыть": "Nascondi",
    "Спрайты": "Sprite",
    "Скажи что-нибудь первым!": "Dì qualcosa per primo!",
    "Это сцена открытого мира! Вы управляете сюжетом.": "Questa è una scena in open world! Sei tu a guidare la storia.",
    "Описывайте новых персонажей прямо в сообщении, например: «К нам подходит загадочная девушка в красном платье».": "Descrivi i nuovi personaggi direttamente nel messaggio, per esempio: «Si avvicina a noi una ragazza misteriosa con un vestito rosso».",
    "Меняйте локацию: «Мы идём в заброшенный замок».": "Cambia luogo: «Andiamo al castello abbandonato».",
    "Каждая генерация изображения стоит {0} ⭐ (изображение генерируется только при создании нового персонажа или локации).": "Ogni immagine generata costa {0} ⭐ (l'immagine viene creata solo quando compare un nuovo personaggio o luogo).",
    "Если вы отключите генерацию изображений, рекомендуем использовать режим чата. Включите его в меню.": "Se disattivi la generazione di immagini, ti consigliamo la modalità chat. Puoi attivarla dal menu.",
    "Генерация изображений ({0} ⭐ за изображение)": "Generazione di immagini ({0} ⭐ per immagine)",
    "Аниме": "Anime",
    "Реалистичный": "Realistico",
    "Понятно": "Ho capito",
    "Спасибо, что прошли новеллу. Делитесь впечатлениями в нашем чате - нам очень важна обратная связь.": "Grazie per aver completato la novel. Raccontaci le tue impressioni nella nostra chat: il tuo parere è preziosissimo.",
    "Поддержать проект можно через Telegram бота @ainovel_helper_bot.": "Puoi sostenere il progetto tramite il bot Telegram @ainovel_helper_bot.",
    "Вернуться на главную": "Torna alla home",
    "Требуется подписка на Telegram": "Iscrizione a Telegram richiesta",
    "Присоединитесь к нашей Telegram группе, затем перейдите к {0} и вставьте этот код верификации. Если вы уже в группе, просто вставьте код боту.": "Entra nel nostro gruppo Telegram, poi apri {0} e incolla questo codice di verifica. Se sei già nel gruppo, invia semplicemente il codice al bot.",
    "Обновите страницу после подтверждения подписки": "Aggiorna la pagina dopo la conferma dell'iscrizione",
    "Присоединиться к группе": "Entra nel gruppo",
    "Скопировано!": "Copiato!",
    "Открыть Telegram бота": "Apri il bot Telegram",
    "Обновить": "Aggiorna",
    "Требуется оплата": "Pagamento richiesto",
    "Требуется вход": "Accesso richiesto",
    "Цена: {0} Telegram Stars или {1} рублей через банк": "Prezzo: {0} Telegram Stars o {1} rubli tramite bonifico bancario",
    "Перейдите в {0}, вставьте эту строку и оплатите с помощью Stars или через денежный перевод в банк. У бота есть все необходимые инструкции. Затем вернитесь и обновите страницу.": "Apri {0}, incolla questa stringa e paga con le Stars o tramite bonifico bancario. Il bot ha tutte le istruzioni necessarie. Poi torna qui e aggiorna la pagina.",
    "Пожалуйста, войдите или зарегистрируйтесь для покупки этого контента.": "Accedi o registrati per acquistare questo contenuto.",
    "Сообщение для вставки в бота:": "Messaggio da incollare nel bot:",
    "Скопировать": "Copia",
    "Войти": "Accedi",
    "⭐ Недостаточно звёзд": "⭐ Stelle insufficienti",
    "Недостаточно звёзд для этого хода. Нужно больше ⭐ для взаимодействия с персонажами.": "Stelle insufficienti per questo turno. Ti servono più ⭐ per interagire con i personaggi.",
    " + {0} ⭐ за каждое сгенерированное изображение": " + {0} ⭐ per ogni immagine generata",
    "1 ход стоит минимум 10 ⭐": "Un turno costa almeno 10 ⭐",
    "Пополнить звёзды в Моём аккаунте": "Ricarica le stelle in Il mio account",
    "📺 Или смотрите рекламу и получайте бесплатные звёзды": "📺 Oppure guarda le pubblicità e ottieni stelle gratis",
    "Отмена": "Annulla",
    "Доступ ограничен — CSAM": "Accesso limitato — CSAM",
    "Ваш запрос нарушил правила безопасности контента ({0}/5).": "La tua richiesta ha violato le regole di sicurezza dei contenuti ({0}/5).",
    "Вы достигли максимального количества нарушений и не можете продолжать играть в новеллы.": "Hai raggiunto il numero massimo di violazioni e non puoi più giocare alle novel.",
    "При достижении 5 нарушений доступ к новеллам будет заблокирован.": "Al raggiungimento di 5 violazioni l'accesso alle novel verrà bloccato.",
    "Если вы считаете, что это ошибка, напишите нам:": "Se pensi che sia un errore, scrivici:",
    "Вернуться к сообщению?": "Tornare a questo messaggio?",
    "Прогресс после этого сообщения будет недоступен для продолжения, если вы не сделали сохранение. Вернуться к этому моменту?": "I progressi successivi a questo messaggio non saranno più riprendibili se non hai salvato. Tornare a questo punto?",
    "Вернуться": "Torna indietro",
    "Сохранения": "Salvataggi",
    "Загрузить": "Carica",
    "Удалить": "Elimina",
    "Сохранений не найдено": "Nessun salvataggio trovato",
    "Имя сохранения": "Nome del salvataggio",
    "Сохранить": "Salva",
    "📜 История": "📜 Cronologia",
    "Нажмите, чтобы перейти к этому сообщению": "Tocca per andare a questo messaggio",
    "Текущее": "Attuale",
    "История пуста": "Cronologia vuota",
    "🔇 Остановить музыку": "🔇 Ferma la musica",
    "🎵 Включить музыку": "🎵 Attiva la musica",
    "💾 Сохранения": "💾 Salvataggi",
    "🔍 Выйти из полноэкранного режима": "🔍 Esci da schermo intero",
    "⛶ Полноэкранный режим": "⛶ Schermo intero",
    "👥 Кол-во показывающихся персонажей: {0}": "👥 Personaggi mostrati: {0}",
    "🎭 Визуальный режим": "🎭 Modalità visiva",
    "💬 Режим чата": "💬 Modalità chat",
    "✍️ Пожелания к ответам ИИ": "✍️ Preferenze per le risposte dell'IA",
    "🔄 Новая игра / изменить биографию": "🔄 Nuova partita / modifica biografia",
    "🚩 Сообщить об ошибке / задать вопрос": "🚩 Segnala un errore / fai una domanda",
    "🏠 Вернуться на главную": "🏠 Torna alla home",
    "Как ИИ должен писать ответы": "Come l'IA deve scrivere le risposte",
    "Например: пиши длиннее и подробнее, больше описаний окружения, меньше вопросов в конце реплик...": "Per esempio: scrivi risposte più lunghe e dettagliate, descrivi di più l'ambiente, meno domande alla fine...",
    "Сохранение...": "Salvataggio...",
    "💾 Сохранить": "💾 Salva",
    "🌍 Мир": "🌍 Mondo",
    "Не удалось загрузить информацию.": "Impossibile caricare le informazioni.",
    "📍 Вы здесь:": "📍 Sei qui:",
    "Неизвестно": "Sconosciuto",
    "👤 В сцене:": "👤 Nella scena:",
    "Никого": "Nessuno",
    "🎨 Стиль изображений": "🎨 Stile delle immagini",
    "💾 Сохранить настройки изображений": "💾 Salva impostazioni immagini",
    "👥 Персонажи": "👥 Personaggi",
    "Пока нет персонажей.": "Ancora nessun personaggio.",
    "Без имени": "Senza nome",
    "💀 Мёртв": "💀 Morto",
    "● В сцене": "● Nella scena",
    "🗺️ Локации": "🗺️ Luoghi",
    "Пока нет локаций.": "Ancora nessun luogo.",
    "📍 Здесь": "📍 Qui",
    "🤖 Выбрать ИИ Модель": "🤖 Scegli il modello IA",
    " + {0} ⭐/изображение": " + {0} ⭐/immagine",
    "⚠️ Тестовая модель": "⚠️ Modello di prova",
    "Эта модель тестовая и может ошибаться. Если что-то не понравится — вернитесь к 💍 Принцессе или 👑 Королеве, они самые надёжные.": "Questo modello è di prova e può sbagliare. Se qualcosa non ti convince, torna a 💍 Principessa o 👑 Regina: sono le più affidabili.",
    "Также лучше сменить локацию (сделать выбор), чтобы диалог стал пустым — новую модель лучше начинать с чистого листа.": "Conviene anche cambiare luogo (fai una scelta) così il dialogo riparte vuoto: un modello nuovo rende meglio partendo da zero.",
    "Понятно, выбрать": "Ho capito, scegli",
    "Ошибка загрузки игры": "Errore nel caricamento della partita",
    "Ошибка взаимодействия с игрой": "Errore nell'interazione con la partita",
    "Загрузка игры...": "Caricamento della partita...",
    "Повторить": "Riprova",
    "Вернуться к новелле": "Torna alla novel",
    "Конец": "Fine",
    "Отправка...": "Invio...",
    "Продолжить": "Continua",
  },
  polish: {
    "📝 Базовая память": "📝 Pamięć podstawowa",
    "📚 Расширенная память": "📚 Pamięć rozszerzona",
    "Цена ×1 · обычная память персонажей": "Cena ×1 · standardowa pamięć postaci",
    "Цена ×2 · персонажи помнят больше": "Cena ×2 · postacie pamiętają więcej",
    "🔄 Перезагрузить диалог": "🔄 Przeładuj dialog",
    "✅ Диалог перезагрузится со следующим сообщением": "✅ Dialog zostanie przeładowany przy następnej wiadomości",
    "Используйте, когда в нескольких сообщениях подряд есть ошибки в тексте: сильные повторы, много иностранных слов или другие ошибки. ИИ частично забудет последние 20 сообщений. После перезагрузки кратко опишите в следующем сообщении, что сейчас происходит, чтобы персонажи вспомнили, что было.": "Użyj, gdy kilka wiadomości z rzędu zawiera błędny tekst: dużo powtórzeń, wiele obcych słów albo inne błędy. AI częściowo zapomni ostatnie 20 wiadomości. Po przeładowaniu krótko opisz w następnej wiadomości, co się teraz dzieje, aby postacie przypomniały sobie, co było.",
    "Лор сохранён": "Lore zapisane",
    "📜 Свой лор": "📜 Własne lore",
    "Дополнительные детали истории": "Dodatkowe szczegóły historii",
    "Например: у героя есть старший брат, в городе действует тайный орден магов...": "Na przykład: bohater ma starszego brata, w mieście działa tajny zakon magów...",
    "Сириус": "Syriusz",
    "Аврора": "Aurora",
    "Вега": "Wega",
    "🎨 Стиль изображений": "🎨 Styl obrazów",
    "🤖 Модель генерации": "🤖 Model generowania",
    'Спасибо, что прошли новеллу!': 'Dziękujemy za przejście powieści!',
    "Произошла ошибка. Попробуйте снова или позже.": "Coś poszło nie tak. Spróbuj ponownie teraz lub później.",
    "Пожелания сохранены": "Życzenia zapisane",
    "Вы": "Ty",
    "Дневной лимит взаимодействий для этой история исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "Wyczerpałeś dzienny limit interakcji w tej historii. Wróć jutro!\n\nMożesz wrócić do tej historii za {0} godzin.",
    "Дневной лимит взаимодействий для этой истории исчерпан. Возвращайтесь завтра!\n\nВы можете вернуться через {0} часов, чтобы продолжить эту историю.": "Wyczerpałeś dzienny limit interakcji w tej historii. Wróć jutro!\n\nMożesz wrócić do tej historii za {0} godzin.",
    "Настройки изображений сохранены": "Ustawienia obrazów zapisane",
    "← Выйти": "← Wyjdź",
    "Настройка вашего персонажа": "Ustawienia twojej postaci",
    "Имя вашего персонажа": "Imię twojej postaci",
    "Ваш пол": "Twoja płeć",
    "Мужской": "Mężczyzna",
    "Женский": "Kobieta",
    "Добавить вашу биографию": "Dodaj swoją biografię",
    "Описание персонажа": "Opis postaci",
    "Добавьте дополнительные детали персонажа (максимум 2500 символов)...": "Dodaj więcej szczegółów o postaci (maksymalnie 2500 znaków)...",
    "Мне исполнилось 18 лет": "Mam ukończone 18 lat",
    "Отправить": "Wyślij",
    "Что-то пошло не так...": "Coś poszło nie tak...",
    "Вернуться к поиску": "Wróć do wyszukiwania",
    "Загрузка...": "Ładowanie...",
    'Играть — {0}': "Graj — {0}",
    "Мир: персонажи и локации": "Świat: postacie i lokacje",
    "Показать персонажей": "Pokaż postacie",
    "Скрыть персонажей": "Ukryj postacie",
    "Выборы:": "Wybory:",
    "Введите ваше сообщение...": "Wpisz swoją wiadomość...",
    "Подсказка": "Podpowiedź",
    "Варианты ответа": "Propozycje odpowiedzi",
    "Не удалось получить подсказки": "Nie udało się pobrać podpowiedzi",
    "Продолжить ➤": "Dalej ➤",
    "Нажмите на экран для продолжения": "Dotknij ekranu, aby kontynuować",
    "Меню": "Menu",
    "История": "Historia",
    "Мир": "Świat",
    "Скрыть": "Ukryj",
    "Спрайты": "Sprite'y",
    "Скажи что-нибудь первым!": "Powiedz coś pierwszy!",
    "Это сцена открытого мира! Вы управляете сюжетом.": "To scena otwartego świata! To ty prowadzisz fabułę.",
    "Описывайте новых персонажей прямо в сообщении, например: «К нам подходит загадочная девушка в красном платье».": "Opisuj nowe postacie prosto w wiadomości, na przykład: „Podchodzi do nas tajemnicza dziewczyna w czerwonej sukni”.",
    "Меняйте локацию: «Мы идём в заброшенный замок».": "Zmieniaj lokację: „Idziemy do opuszczonego zamku”.",
    "Каждая генерация изображения стоит {0} ⭐ (изображение генерируется только при создании нового персонажа или локации).": "Każdy wygenerowany obraz kosztuje {0} ⭐ (obraz powstaje tylko przy pojawieniu się nowej postaci lub lokacji).",
    "Если вы отключите генерацию изображений, рекомендуем использовать режим чата. Включите его в меню.": "Jeśli wyłączysz generowanie obrazów, polecamy tryb czatu. Włączysz go w menu.",
    "Генерация изображений ({0} ⭐ за изображение)": "Generowanie obrazów ({0} ⭐ za obraz)",
    "Аниме": "Anime",
    "Реалистичный": "Realistyczny",
    "Понятно": "Rozumiem",
    "Спасибо, что прошли новеллу. Делитесь впечатлениями в нашем чате - нам очень важна обратная связь.": "Dziękujemy za ukończenie powieści. Podziel się wrażeniami na naszym czacie — twoja opinia jest dla nas bardzo ważna.",
    "Поддержать проект можно через Telegram бота @ainovel_helper_bot.": "Projekt możesz wesprzeć przez bota na Telegramie @ainovel_helper_bot.",
    "Вернуться на главную": "Wróć na stronę główną",
    "Требуется подписка на Telegram": "Wymagana subskrypcja na Telegramie",
    "Присоединитесь к нашей Telegram группе, затем перейдите к {0} и вставьте этот код верификации. Если вы уже в группе, просто вставьте код боту.": "Dołącz do naszej grupy na Telegramie, następnie otwórz {0} i wklej ten kod weryfikacyjny. Jeśli jesteś już w grupie, po prostu wyślij kod botowi.",
    "Обновите страницу после подтверждения подписки": "Odśwież stronę po potwierdzeniu subskrypcji",
    "Присоединиться к группе": "Dołącz do grupy",
    "Скопировано!": "Skopiowano!",
    "Открыть Telegram бота": "Otwórz bota Telegram",
    "Обновить": "Odśwież",
    "Требуется оплата": "Wymagana płatność",
    "Требуется вход": "Wymagane logowanie",
    "Цена: {0} Telegram Stars или {1} рублей через банк": "Cena: {0} Telegram Stars lub {1} rubli przelewem bankowym",
    "Перейдите в {0}, вставьте эту строку и оплатите с помощью Stars или через денежный перевод в банк. У бота есть все необходимые инструкции. Затем вернитесь и обновите страницу.": "Otwórz {0}, wklej ten ciąg i zapłać Starsami lub przelewem bankowym. Bot ma wszystkie potrzebne instrukcje. Potem wróć i odśwież stronę.",
    "Пожалуйста, войдите или зарегистрируйтесь для покупки этого контента.": "Zaloguj się lub załóż konto, aby kupić tę treść.",
    "Сообщение для вставки в бота:": "Wiadomość do wklejenia botowi:",
    "Скопировать": "Kopiuj",
    "Войти": "Zaloguj się",
    "⭐ Недостаточно звёзд": "⭐ Za mało gwiazdek",
    "Недостаточно звёзд для этого хода. Нужно больше ⭐ для взаимодействия с персонажами.": "Za mało gwiazdek na tę turę. Potrzebujesz więcej ⭐, aby wchodzić w interakcje z postaciami.",
    " + {0} ⭐ за каждое сгенерированное изображение": " + {0} ⭐ za każdy wygenerowany obraz",
    "1 ход стоит минимум 10 ⭐": "Jedna tura kosztuje minimum 10 ⭐",
    "Пополнить звёзды в Моём аккаунте": "Doładuj gwiazdki w Moim koncie",
    "📺 Или смотрите рекламу и получайте бесплатные звёзды": "📺 Albo oglądaj reklamy i zdobywaj darmowe gwiazdki",
    "Отмена": "Anuluj",
    "Доступ ограничен — CSAM": "Dostęp ograniczony — CSAM",
    "Ваш запрос нарушил правила безопасности контента ({0}/5).": "Twoje zapytanie naruszyło zasady bezpieczeństwa treści ({0}/5).",
    "Вы достигли максимального количества нарушений и не можете продолжать играть в новеллы.": "Osiągnąłeś maksymalną liczbę naruszeń i nie możesz dalej grać w powieści.",
    "При достижении 5 нарушений доступ к новеллам будет заблокирован.": "Po osiągnięciu 5 naruszeń dostęp do powieści zostanie zablokowany.",
    "Если вы считаете, что это ошибка, напишите нам:": "Jeśli uważasz, że to pomyłka, napisz do nas:",
    "Вернуться к сообщению?": "Wrócić do tej wiadomości?",
    "Прогресс после этого сообщения будет недоступен для продолжения, если вы не сделали сохранение. Вернуться к этому моменту?": "Postępów po tej wiadomości nie da się kontynuować, jeśli nie zapisałeś gry. Wrócić do tego momentu?",
    "Вернуться": "Wróć",
    "Сохранения": "Zapisy",
    "Загрузить": "Wczytaj",
    "Удалить": "Usuń",
    "Сохранений не найдено": "Nie znaleziono zapisów",
    "Имя сохранения": "Nazwa zapisu",
    "Сохранить": "Zapisz",
    "📜 История": "📜 Historia",
    "Нажмите, чтобы перейти к этому сообщению": "Dotknij, aby przejść do tej wiadomości",
    "Текущее": "Aktualne",
    "История пуста": "Historia jest pusta",
    "🔇 Остановить музыку": "🔇 Zatrzymaj muzykę",
    "🎵 Включить музыку": "🎵 Włącz muzykę",
    "💾 Сохранения": "💾 Zapisy",
    "🔍 Выйти из полноэкранного режима": "🔍 Wyjdź z pełnego ekranu",
    "⛶ Полноэкранный режим": "⛶ Pełny ekran",
    "👥 Кол-во показывающихся персонажей: {0}": "👥 Liczba widocznych postaci: {0}",
    "🎭 Визуальный режим": "🎭 Tryb wizualny",
    "💬 Режим чата": "💬 Tryb czatu",
    "✍️ Пожелания к ответам ИИ": "✍️ Preferencje dotyczące odpowiedzi AI",
    "🔄 Новая игра / изменить биографию": "🔄 Nowa gra / zmień biografię",
    "🚩 Сообщить об ошибке / задать вопрос": "🚩 Zgłoś błąd / zadaj pytanie",
    "🏠 Вернуться на главную": "🏠 Wróć na stronę główną",
    "Как ИИ должен писать ответы": "Jak AI ma pisać odpowiedzi",
    "Например: пиши длиннее и подробнее, больше описаний окружения, меньше вопросов в конце реплик...": "Na przykład: pisz dłużej i bardziej szczegółowo, więcej opisów otoczenia, mniej pytań na końcu wypowiedzi...",
    "Сохранение...": "Zapisywanie...",
    "💾 Сохранить": "💾 Zapisz",
    "🌍 Мир": "🌍 Świat",
    "Не удалось загрузить информацию.": "Nie udało się wczytać informacji.",
    "📍 Вы здесь:": "📍 Jesteś tutaj:",
    "Неизвестно": "Nieznane",
    "👤 В сцене:": "👤 W scenie:",
    "Никого": "Nikogo",
    "🎨 Стиль изображений": "🎨 Styl obrazów",
    "💾 Сохранить настройки изображений": "💾 Zapisz ustawienia obrazów",
    "👥 Персонажи": "👥 Postacie",
    "Пока нет персонажей.": "Na razie brak postaci.",
    "Без имени": "Bez imienia",
    "💀 Мёртв": "💀 Martwy",
    "● В сцене": "● W scenie",
    "🗺️ Локации": "🗺️ Lokacje",
    "Пока нет локаций.": "Na razie brak lokacji.",
    "📍 Здесь": "📍 Tutaj",
    "🤖 Выбрать ИИ Модель": "🤖 Wybierz model AI",
    " + {0} ⭐/изображение": " + {0} ⭐/obraz",
    "⚠️ Тестовая модель": "⚠️ Model testowy",
    "Эта модель тестовая и может ошибаться. Если что-то не понравится — вернитесь к 💍 Принцессе или 👑 Королеве, они самые надёжные.": "Ten model jest testowy i może się mylić. Jeśli coś ci nie odpowiada, wróć do 💍 Księżniczki lub 👑 Królowej — są najbardziej niezawodne.",
    "Также лучше сменить локацию (сделать выбор), чтобы диалог стал пустым — новую модель лучше начинать с чистого листа.": "Warto też zmienić lokację (dokonać wyboru), żeby dialog był pusty — nowy model lepiej zaczynać z czystą kartą.",
    "Понятно, выбрать": "Rozumiem, wybierz",
    "Ошибка загрузки игры": "Błąd wczytywania gry",
    "Ошибка взаимодействия с игрой": "Błąd interakcji z grą",
    "Загрузка игры...": "Wczytywanie gry...",
    "Повторить": "Ponów",
    "Вернуться к новелле": "Wróć do powieści",
    "Конец": "Koniec",
    "Отправка...": "Wysyłanie...",
    "Продолжить": "Dalej",
  },
};

export default play;
